import 'css-chunk:src/components/App.module.scss';export default {
  "layout": "_layout_nosd0_1",
  "left": "_left_nosd0_9",
  "right": "_right_nosd0_17",
  "top": "_top_nosd0_22",
  "todo": "_todo_nosd0_27",
  "entry": "_entry_nosd0_38"
};